import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import { DROP_SEND_PLATINUM_EMAIL } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { calendlyUrl } from 'root/src/shared/constants/pageData'
import { DROP_EVENT_PAGE_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'

export default mnemonicId => async (dispatch, getState) => {
	const state = getState()
	window.open(calendlyUrl, '_blank')
	await invokeApiRequest(DROP_SEND_PLATINUM_EMAIL, { mnemonicId }, state)
	return pushRouteClient({
		routeId: DROP_EVENT_PAGE_ROUTE_ID,
		routeParams: { recordId: mnemonicId },
	})
}
